function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.46 283.46"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Power_outtage"
}, /*#__PURE__*/React.createElement("g", {
  id: "Power_x5F_outage_x5F_outlined"
}, /*#__PURE__*/React.createElement("path", {
  d: "M283.466 276.379H0L141.6 14.173 283.466 276.38zM47.3 248.2h188.6L141.733 70.867 47.3 248.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.633 198.425h17.5l24.5-42.52h-23l15.6-28.347h-17.5l-24.9 42.52h23zM141.66 233.9c-2.1 0-4.1-.4-5.9-1.4-3.3-1.9-5-5.8-4.7-10.1.5-6.2 4.5-9.5 9.8-9.8 1.7-.1 3.4 0 5 .6 3.6 1.3 5.8 3.9 6.4 8.1.5 3.4 0 6.6-2.3 9.3-2 2.4-4.6 3.2-7.5 3.3h-.8z"
})))));